module.exports = __webpack_public_path__ + "static/media/help-24px.f06ff9e4.svg";